const sections = document.querySelectorAll('.card-fan');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const pinEnabled = window.matchMedia('(min-width: 768px)');

// Share of 0–1 progress that each card waits after the previous one.
const STAGGER = 0.14;
// Finish arriving this far into the pin (0 = as the section fills the screen).
const SETTLE_INTO_PIN = 0.65;

function setContainerClasses(containers, activeIndex) {
  containers.forEach((container, i) => {
    container.classList.toggle('is-visible', i === activeIndex);
    container.classList.toggle('is-before-scroll', i < activeIndex);
    container.classList.toggle('is-after-scroll', i > activeIndex);
  });
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function pinProgress(rect, vh) {
  if (rect.top >= 0) return 0;
  if (rect.bottom <= vh) return 1;
  const travel = rect.height - vh;
  if (travel <= 0) return 1;
  return clamp(-rect.top / travel, 0, 1);
}

function slideProgress(rect, vh) {
  // 0: section top reaches the bottom of the viewport (just entering)
  // 1: a short way into the pin, then hold
  const start = vh;
  const pinTravel = Math.max(0, rect.height - vh);
  const end = -pinTravel * SETTLE_INTO_PIN;

  if (rect.top >= start) return 0;
  if (rect.top <= end || rect.bottom <= vh) return 1;
  return clamp((start - rect.top) / (start - end), 0, 1);
}

function cardIn(progress, index, count) {
  if (count <= 1) return progress;
  const duration = Math.max(0.2, 1 - STAGGER * (count - 1));
  return clamp((progress - index * STAGGER) / duration, 0, 1);
}

function handleScroll() {
  const vh = window.innerHeight;

  sections.forEach((section) => {
    const cards = section.querySelector('.card-fan__cards');
    const holders = cards ? [...cards.children] : [];
    const containers = section.querySelectorAll('.card-fan__container');
    const containerCount = containers.length;
    const rect = section.getBoundingClientRect();

    if (!pinEnabled.matches) {
      section.classList.remove(
        'is-before-viewport',
        'is-in-viewport',
        'is-after-viewport'
      );
      containers.forEach((container) => {
        container.classList.add('is-visible');
        container.classList.remove('is-before-scroll', 'is-after-scroll');
      });
    } else if (rect.top > 0) {
      section.classList.add('is-before-viewport');
      section.classList.remove('is-in-viewport', 'is-after-viewport');
      setContainerClasses(containers, 0);
    } else if (rect.bottom > vh) {
      const pinned = pinProgress(rect, vh);
      section.classList.add('is-in-viewport');
      section.classList.remove('is-before-viewport', 'is-after-viewport');
      const activeIndex =
        containerCount > 0
          ? Math.min(Math.floor(pinned * containerCount), containerCount - 1)
          : 0;
      setContainerClasses(containers, activeIndex);
    } else {
      section.classList.add('is-after-viewport');
      section.classList.remove('is-before-viewport', 'is-in-viewport');
      setContainerClasses(containers, containerCount - 1);
    }

    if (!cards || reducedMotion.matches || !pinEnabled.matches) {
      holders.forEach((holder) => {
        holder.style.setProperty('--card-fan-in', '1');
      });
      return;
    }

    const progress = slideProgress(rect, vh);
    const count = holders.length;

    holders.forEach((holder, i) => {
      holder.style.setProperty(
        '--card-fan-in',
        cardIn(progress, i, count).toFixed(4)
      );
    });
  });
}

let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(() => {
    handleScroll();
    ticking = false;
  });
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', handleScroll);
reducedMotion.addEventListener('change', handleScroll);
pinEnabled.addEventListener('change', handleScroll);
handleScroll();
